<template>
    <v-card class="upload-thumb-card" :loading="!photo.uploaded" flat tile ripple>
        <v-fab-transition>
            <v-speed-dial v-model="photoEditing" v-if="photo.uploaded && editOptions" 
            absolute top right direction="bottom" transition="slide-x-reverse-transition">
                <template v-slot:activator>
                    <v-btn v-model="photoEditing" color="blue darken-2" dark fab small>
                        <v-icon v-if="photoEditing">mdi-close</v-icon>
                        <v-icon v-else>mdi-image-edit</v-icon>
                    </v-btn>
                </template>
                <v-btn fab color="red" @click.stop="deletePhoto(photo.id)" small>
                    <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
                <v-btn fab color="white" @click.stop="openDialog(photo)" small>
                    <v-icon>mdi-lead-pencil</v-icon>
                </v-btn>
            </v-speed-dial>
        </v-fab-transition>
        <v-card tile flat :to="link" :append="appendLink" color="grey">
            <v-img :lazy-src="photo.thumbnail_file_url" :class="{'v-image__image--preload' : photo.deleting}" aspect-ratio="1" :src="photo.uploaded ? photo.file_url : ''">
                <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-row>
                </template>
                <v-row class="fill-height ma-0" align="center" justify="center" v-if="!photo.uploaded || photo.deleting">
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
            </v-img>
        </v-card>
        <template v-slot:progress>
            <v-progress-linear v-model="photo.uploadProgress" height="15" color="blue-grey" absolute bottom striped>
                <strong>{{ photo.uploadProgress }} %</strong>
            </v-progress-linear>
        </template>
    </v-card>
</template>
<script>
export default {
    props: {
        photo: Object,
        link: String,
        appendLink: Boolean,
        editOptions: Boolean
    },
    data: () => ({
        photoEditing: false
    }),
    methods: {
        deletePhoto(id) {
            this.photoEditing = false
            this.$emit('deletePhoto', id)
        },

        openDialog(photo) {
            this.photoEditing = false
            this.$emit('openDialog', photo)
        }
    }
}
</script>